// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".U3ikviKZ {\n  color: var(--lightGreyText);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"optional-label": "U3ikviKZ"
};
export default ___CSS_LOADER_EXPORT___;
